import { RootState } from './../../../app/store';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useQueryParams } from 'use-query-params';
import { useEventFeed } from '../../../api/useEventFeed';
import { useEventResults } from '../../../api/useEventResults';
import { AppQueryParamsConfigMap } from '../../../app/constants';
import { Disciplines, Sort } from '../../../domain';

export default function useResultsSort() {
  const [{ e: eventId, c: classId }] = useQueryParams(AppQueryParamsConfigMap);

  const searchQuery = useSelector(
    (state: RootState) => state.app.searchQuery.results,
  );

  const [sort, setSort] = useState<Sort>({
    field: 'overallPlace',
    order: 'asc',
  });

  const { data: activeEvent } = useEventFeed({ eventId });

  const { data: results } = useEventResults(
    eventId,
    classId,
    searchQuery,
    sort,
  );

  const orderByPlacing = results?.[0]?.orderLiveResultsByPlacing;


  const changeSort = (field: string) => {
    setSort({ field, order: sort?.order === 'asc' ? 'desc' : 'asc' });
  };

  useEffect(() => {
    if (orderByPlacing === undefined) {
      return;
    }

    let sortField = orderByPlacing ? 'overallPlace' : 'dressageTime';

    if (activeEvent?.discipline === Disciplines.Showjumping) {
      // setting place as default for all cases since it has no time field
      sortField = 'sjPlace';
    }

    if (
      activeEvent?.discipline === Disciplines.EventerTrial &&
      orderByPlacing === false
    ) {
      // evTrialScoringTime for non-orderByPlacing cases (else default overallPlace)
      sortField = 'evTrialScoringTime';
    }

    if (
      activeEvent?.discipline === Disciplines.EventerTrial &&
      orderByPlacing === false
    ) {
      // evTrialScoringTime for non-orderByPlacing cases (else default overallPlace)
      sortField = 'evTrialScoringTime';
    }

    if (
      activeEvent?.discipline === Disciplines.HunterTrials &&
      orderByPlacing === false
    ) {
      // evTrialScoringTime for non-orderByPlacing cases (else default overallPlace)
      sortField = 'htTimeTaken';
    }

    if (
      activeEvent?.discipline === Disciplines.Shows ||
      activeEvent?.discipline === Disciplines.MixedEvents
    ) {
      // setting selectedResult as default for all cases since it has no time field
      sortField = 'selectedResult';
    }

    setSort({ field: sortField, order: 'asc' });

  }, [activeEvent?.discipline, orderByPlacing]);

  return { changeSort, sort };
}
